import React from 'react';
import { Grid } from '@material-ui/core';
import TextField from '../TextField';
import styled from 'styled-components';
import debounce from 'lodash/debounce';

const AllNotes = styled.div`
  color: #62727b;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 7px;
  word-break: break-word;
  border-bottom: 1px solid black;
  font-size: 12px;
  // &&& b {
  //   color: black;
  // }
`;
const AllNotesTitle = styled.div`
  font-weight: bold;
  margin-bottom: 5px;
`;
const AllNotesContainer = styled.div`
  width: 100%;
  padding: 10px 0;
  margin-bottom: 10px;
`;
const NotesGrid = styled(Grid)`
  padding-top: 10px;
`;

class NotesCard extends React.Component {
  changeInNote = debounce(event => {
    this.props.trigerHandleChange(event);
  }, 200);

  render() {
    const { stateValues, trigerHandleChange, id, isEdit, isReuse } = this.props;

    return (
      <NotesGrid item xs={12}>
        {(isEdit || isReuse) && (
          <AllNotesContainer>
            <AllNotesTitle>All notes</AllNotesTitle>
            <AllNotes id={'allNotes'} />
          </AllNotesContainer>
        )}
        <TextField
          disabled={false}
          stateValue={stateValues}
          trigerHandleChange={event => this.changeInNote(event.target.value)}
          labelText={'Add note'}
          stateName={'notes'}
          id={id}
          ref="notes"
        />
      </NotesGrid>
    );
  }
}

export default NotesCard;
